<div class="new-feature-banner__content">
    <ls-picture
        class="new-feature-banner__bg"
        [src]="(banner().image.backgroundDesk || banner().image.backgroundMob || '') | resolveMinioUrlMirror"
    />

    <span class="new-feature-banner__text _system-sub-xl _800">
        @if ((banner().texts | contentTextByName : 'title')) {
            <span class="new-feature-banner__text-mark">
                {{ (banner().texts | contentTextByName : 'title')?.text!}}
            </span>
        }

        @if ((banner().texts | contentTextByName : 'subtitle')) {
            {{ (banner().texts | contentTextByName : 'subtitle')?.text! }}
        }
    </span>

    <ls-picture
        class="new-feature-banner__img"
        [src]="(banner().image.characterDesk || banner().image.backgroundMob || '') | resolveMinioUrlMirror"
    />
</div>

@if (banner() | bannerMetadata : 'TC') {
    <a
        class="new-feature-banner__link"
        [routerLink]="[(banner() | bannerMetadata : 'TC') | localize]"
        (click)="linkClick()"
    ></a>
}
